// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"dcd9554a","533":"243c7ca6"}[chunkId] + ".chunk.css";
};